import * as React from "react";

function SignalStreamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M505.9 71.75c-8.961-9.781-24.18-10.37-33.95-1.406-9.759 8.969-10.4 24.16-1.423 33.91 77.04 83.69 77.04 219.8 0 303.5-8.977 9.75-8.336 24.94 1.423 33.91C476.5 445.9 482.4 448 488.2 448c6.475 0 12.95-2.594 17.69-7.75 93.51-101.55 93.51-266.95.01-368.5zM392.3 149.1c-9.962 8.75-10.95 23.91-2.19 33.87 34.97 39.78 34.97 104.5 0 144.3-8.758 9.969-7.772 25.12 2.19 33.87 4.567 3.1 10.21 5.969 15.84 5.969 6.678 0 13.32-2.75 18.06-8.156 50.33-57.25 50.33-150.4 0-207.7-8.8-9.053-23.9-10.053-33.9-2.153zM104.1 70.35c-9.728-8.969-24.94-8.375-33.95 1.406-93.51 101.6-93.51 266.9 0 368.5C74.87 445.4 81.34 448 87.82 448c5.818 0 11.65-2.094 16.26-6.344 9.759-8.969 10.4-24.16 1.423-33.91-77.04-83.69-77.04-219.8 0-303.5C114.5 94.5 113.8 79.32 104.1 70.35zm79.6 78.75c-9.9-7.9-25.1-6.9-33.9 3.1-50.33 57.25-50.33 150.4 0 207.7 4.739 5.406 11.39 8.156 18.06 8.156 5.614 0 11.28-1.969 15.84-5.969 9.962-8.75 10.95-23.91 2.19-33.87-34.97-39.78-34.97-104.5 0-144.3 8.81-10.017 7.81-25.217-2.19-34.817zM288 216c-22.11 0-40.02 17.91-40.02 39.1S265.9 296 288 296s40.02-17.91 40.02-39.1S310.1 216 288 216z"
  }));
}

const ForwardRef = React.forwardRef(SignalStreamIcon);
export default ForwardRef;